import { VG_ORANGE } from "../lib/brand";

// Simple reusable page banner with title + optional subtitle and background image.
export const PageHero = ({ title, subtitle, image, testId }) => (
  <section
    data-testid={testId || "page-hero"}
    className="relative overflow-hidden bg-[#307fbf]"
  >
    {image && (
      <img
        src={image}
        alt=""
        className="absolute inset-0 h-full w-full object-cover opacity-30"
      />
    )}
    <div className="relative mx-auto max-w-7xl px-4 py-10 sm:py-14 md:py-20">
      <div className="h-1 w-12 sm:w-16 mb-4 sm:mb-5" style={{ backgroundColor: VG_ORANGE }} />
      <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl font-extrabold text-white tracking-tight break-words">
        {title}
      </h1>
      {subtitle && (
        <p className="mt-3 sm:mt-4 max-w-2xl text-sm sm:text-base md:text-lg text-white/95">{subtitle}</p>
      )}
    </div>
  </section>
);
